import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import OutlierDetectorTableService from '../service/OutlierDetectorTableService';
import AddOutlierDetectorButton from '../component/AddOutlierDetectorButton';

const config = data => {
	return {
		key: 'outlierDetectorTable',
		topic: 'outlierDetector',
		service: OutlierDetectorTableService,
		editFormState: item => `/outlier-detector/edit/${item.type}/${item ? item.id : 'new'}`,
		toolbarButtonList: [
			{
				key: 'addNew',
				place: 'before',
				component: AddOutlierDetectorButton
			}
		],
		toolbarAction: ['search', 'refresh'],
		rowAction: ['modify', 'delete'],
		columns: [
			{
				key: 'name'
			},
			{
				key: 'type'
			}
		]
	};
};

function OutlierDetectorTable() {
	const myConfig = config();
	return <TableBrowser config={myConfig} />;
}

export default withReducer('outlierDetectorTable', reducer('outlierDetectorTable'))(OutlierDetectorTable);
